<template>
	<div class="self-produce">
		<div class="flex-g-1">
			<nut-textbox
                class="textarea"
				v-model="value"
				:place-text="'请输入您的个人简介'"
				:max-num="150"
			></nut-textbox>
		</div>
		<div class="action">
			<nut-button block shape="circle" class="submit-btn" @click="clickHandler">保存</nut-button>
		</div>
	</div>
</template>

<script>
import cache from "../../utils/cache";

export default {
	name: 'self-produce',
	metaInfo: {
		title: '个人简介',
		titleTemplate: null,
	},
	data: () => ({
		value: '',
	}),
	created() {
		if(this.$route.query.introduce){
			this.value = this.$route.query.introduce;
		}
	},
	methods:{
		clickHandler(e){
			if(this.value == ''){
				this.$toast.text('个人简介不能为空~');return false;
			}
			this.userUpdate({'introduce':this.value});
		},
		userUpdate(value){
			this.$ajax.post('m/trade/user_info',value).then(res=>{
				this.$toast.text('修改成功~')
				cache.set('introduce', this.value);
				setTimeout(()=>{
					this.$router.push({name:'InstructorInfo'})
				},2000);
			})
		},
	}
}
</script>

<style lang="less" scoped>
.self-produce {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
    height: 100%;
    
    .textarea {
        margin: 10px 14px;
    }
	/deep/ .nut-textbox textarea {
		height: 200px !important;
	}

	.action {
        padding: 10px 14px;
        border-top: 1px solid #E2E2E2;
	}
	.submit-btn {
		background: linear-gradient(
			45deg,
			rgba(60, 67, 236, 1) 0%,
			rgba(0, 194, 255, 1) 100%
		);
	}
}
</style>
